import { httpPost, httpDownload, httpGet } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import {
    getAllOrder,
    setAllOrderError,
    setAllOrderColSearchStr,
    sortAllOrderItems,
    setAllOrderPageSize,
    setAllOrderFilter,
    applyAllOrderFilter,
    applyAllOrderStatusFilter,
    setDefaultAllOrder,
    setFormLoading
} from "../../../constants/model-reducers/external/order/order.settings";
import { convertToFormatLocalDate, convertToFormatTimeZoneDate } from '../../../utils/helpers.utils';
const defaultState = () => ({
    isAllOrderLoaded: false,
    isallOrderError: false,
    allOrderItems: DEFAULT_TABLE_RESULT_MODEL,
    allOrderColSort: '',
    allOrderIsSortedAsc: false,
    allOrderTableFilterList: [],
    allOrderTableFilterApply: false,
    allOrderStatusFilterList: [],
    allOrderTableFilterStatusApply: 0,
});
const initialState = defaultState();
export const orderOrderActions = {
    setDefaultAllOrder: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultAllOrder,
            orderItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    setLoadForm: (isLoad = false) => (dispatch, state) => {
        dispatch({
            type: setFormLoading,
            data: isLoad
        });
    },
    getAllOrder: (pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().orderOrder.allOrderItems;
        const { allOrderIsSortedAsc, allOrderColSort, allOrderTableFilterList, allOrderTableFilterApply, allOrderStatusFilterList, allOrderTableFilterStatusApply } = state().orderOrder;

        var userId = sessionStorage.getItem('UserID');
        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: allOrderColSort,
                IsSortAscending: allOrderIsSortedAsc,
                TableFilterList: allOrderTableFilterList,
                ApplyFilter: allOrderTableFilterApply,
                StatusFilter: allOrderStatusFilterList,
                ApplyStatusFilter: allOrderTableFilterStatusApply,
            };
            var allOrderItems = await httpPost('external/order/getAllOrderItems', data);
            dispatch({
                type: getAllOrder,
                allOrderItems: Object.keys(allOrderItems).length > 0 ? allOrderItems : DEFAULT_TABLE_RESULT_MODEL,
                isAllOrderLoaded: true,
                isAllOrderError: false
            });
        }
        catch (e) {
            dispatch({
                type: setAllOrderError,
                isAllOrderError: true,
                isAllOrderLoaded: false
            });
        }
    },
    setAllOrderColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { allOrderItems } = state().orderOrder;
        var allOrderItemsUpd = {
            ...allOrderItems,
            "Headers": {
                ...allOrderItems.Headers,
                [key]: {
                    ...allOrderItems.Headers[key],
                    searchString: val
                }
            }
        }
        dispatch({
            type: setAllOrderColSearchStr,
            data: allOrderItemsUpd,
            isAllOrderError: false,
            isAllOrderLoaded: true
        });
    },
    sortAllOrderItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().orderOrder.allOrderItems.Pagination;
        const { allOrderItems, allOrderTableFilterList, allOrderTableFilterApply, allOrderStatusFilterList, allOrderTableFilterStatusApply } = state().orderOrder;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: allOrderItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...allOrderItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: allOrderTableFilterList,
            ApplyFilter: allOrderTableFilterApply,
            StatusFilter: allOrderStatusFilterList,
            ApplyStatusFilter: allOrderTableFilterStatusApply,
        };
        var resAllOrderItems = await httpPost('external/order/getAllOrderItems', data);
        if (resAllOrderItems.ok === false) {
            dispatch({
                type: setAllOrderError,
                isAllOrderError: true,
                isAllOrderLoaded: false
            });
        } else {
            dispatch({
                type: sortAllOrderItems,
                allOrderItems: Object.keys(resAllOrderItems).length > 0 ? resAllOrderItems : DEFAULT_TABLE_RESULT_MODEL,
                allOrderColSort: columnClicked,
                allOrderIsSortedAsc: isSortedAsc,
                isAllOrderLoaded: true
            });
        }
    },
    resizeAllOrderPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setAllOrderPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    applyAllOrderStatusFilter: (isStatusApply) => (dispatch, state) => {

        dispatch({
            type: applyAllOrderStatusFilter,
            applyStatusFilter: isStatusApply,
        });
    },
    extractAllOrder: () => async (dispatch, state) => {
        const { Headers } = state().orderOrder.allOrderItems;
        const { allOrderIsSortedAsc, allOrderColSort, allOrderTableFilterList, allOrderTableFilterApply, allOrderStatusFilterList, allOrderTableFilterStatusApply } = state().orderOrder;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        var filename = `ATEM ${dealName} Order Extract -  ${formattedTimeZoneDate}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: allOrderColSort,
            IsSortAscending: allOrderIsSortedAsc,
            FileName: filename,
            TableFilterList: allOrderTableFilterList,
            ApplyFilter: allOrderTableFilterApply,
            StatusFilter: allOrderStatusFilterList,
            ApplyStatusFilter: allOrderTableFilterStatusApply,
        };
        httpDownload('external/order/getAllOrderExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
    addAllOrderFilter: (tableFilter) => (dispatch, state) => {
        const { allOrderTableFilterList } = state().orderOrder;
        var filterList = [...allOrderTableFilterList, tableFilter];
        dispatch({
            type: setAllOrderFilter,
            filterList: filterList
        })
    },
    removeAllOrderFilter: (removeIndex) => (dispatch, state) => {
        const { allOrderTableFilterList } = state().orderOrder;
        var filterList = allOrderTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });
        dispatch({
            type: setAllOrderFilter,
            filterList: filterList
        })
    },
    applyAllOrderFilter: (isApply) => (dispatch, state) => {
        const { allOrderTableFilterList } = state().orderOrder;
        dispatch({
            type: applyAllOrderFilter,
            applyFilter: isApply,
            filterList: isApply ? allOrderTableFilterList : []
        });
    },
    saveAllOrderCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().orderOrder.allOrderItems;
        const { allOrderIsSortedAsc, allOrderColSort, allOrderTableFilterList, allOrderTableFilterApply, allOrderStatusFilterList, allOrderTableFilterStatusApply } = state().orderOrder;
        try {
            var userId = sessionStorage.getItem('UserID');
            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.OrderOrderManagement,
                SelectedCols: selectedCols
            };
            await httpPost('external/order/saveOrderCustomizeColumns', customizeFormData);
            dispatch({
                type: setAllOrderError,
                isAllOrderError: true,
                isAllOrderLoaded: false
            });
            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: allOrderColSort,
                IsSortAscending: allOrderIsSortedAsc,
                TableFilterList: allOrderTableFilterList,
                ApplyFilter: allOrderTableFilterApply,
                StatusFilter: allOrderStatusFilterList,
                ApplyStatusFilter: allOrderTableFilterStatusApply,
            };
            var allOrderItems = await httpPost('external/order/getAllOrderItems', data);
            dispatch({
                type: getAllOrder,
                allOrderItems: Object.keys(allOrderItems).length > 0 ? allOrderItems : DEFAULT_TABLE_RESULT_MODEL,
                isAllOrderLoaded: true,
                isAllOrderError: false
            });
        }
        catch (e) {
            dispatch({
                type: setAllOrderError,
                isAllOrderError: true,
                isAllOrderLoaded: false
            });
        }
    },
    hasStripeCustomerId:(orderId=0) => async (dispatch, state) =>{
        try {
            const result = await httpGet(`external/order/hasStripeCustomerId/${orderId}`);
            return result
        }catch(apiError) {
            return { success: false, 
                message: apiError.message 
            };
        }
    }
};
export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getAllOrder:
            return {
                ...state,
                allOrderItems: action.allOrderItems,
                isAllOrderLoaded: action.isAllOrderLoaded,
                isAllOrderError: action.isAllOrderError
            };
        case setAllOrderError:
            return {
                ...state,
                isAllOrderError: action.isAllOrderError,
                isAllOrderLoaded: action.isAllOrderLoaded
            }
        case setAllOrderColSearchStr:
            return {
                ...state,
                allOrderItems: action.data,
                isAllOrderLoaded: action.isAllOrderLoaded,
                isAllOrderError: action.isAllOrderError
            }
        case sortAllOrderItems:
            return {
                ...state,
                allOrderItems: action.allOrderItems,
                allOrderColSort: action.allOrderColSort,
                allOrderIsSortedAsc: action.allOrderIsSortedAsc,
                isAllOrderLoaded: action.isAllOrderLoaded
            }
        case setAllOrderPageSize:
            return {
                ...state,
                allOrderItems: {
                    ...state.allOrderItems,
                    Pagination: {
                        ...state.allOrderItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setAllOrderFilter:
            return {
                ...state,
                allOrderTableFilterList: action.filterList
            }
        case applyAllOrderFilter:
            return {
                ...state,
                allOrderTableFilterApply: action.applyFilter,
                allOrderTableFilterList: action.filterList
            }
        case applyAllOrderStatusFilter:
            return {
                ...state,
                allOrderTableFilterStatusApply: action.applyStatusFilter,
            }
        case setDefaultAllOrder:
            return initialState;
        case setFormLoading:
                return {
                    ...state
                    , isAllOrderLoaded: action.data
                };
        default:
            return state;
    }
};